import { ObjectDefinitions } from "../types/ObjectDefinitionTypes";

const objects: ObjectDefinitions[] = [
  {
    name: "table_spectrophotometry",
    image: "TableSpectrophotometry",
    type: "sceneObject",
  },
  {
    name: "principle_of_spectrophotometry_poster",
    image: "PrincipleOfSpectrophotometryPoster",
    type: "interactableObject",
  },
  {
    name: "cuvette_rack_spectrophotometry",
    image: "CuvetteRackSpectrophotometry",
    type: "sceneObject",
  },
  {
    name: "cuvette_rack_front_spectrophotometry",
    image: "CuvetteRackFrontSpectrophotometry",
    type: "sceneObject",
  },
  {
    name: "cuvette_spectrophotometry",
    image: "",
    type: "controllableObject",
    defaultState: "empty",
    states: [
      {
        name: "empty",
        altText: "Empty cuvette",
        image: "EmptyCuvetteSpectrophotometry",
      },
      {
        name: "filled",
        image: "FilledCuvetteSpectrophotometry",
      },
      {
        name: "lidded_filled",
        image: "FilledLiddedCuvetteSpectrophotometry",
        altText: "Sample cuvette",
      },
      {
        name: "lidded_diluted_filled",
        altText: "Diluted sample cuvette",
        image: "FilledLiddedCuvetteSpectrophotometry",
      },
      {
        name: "lidded_empty",
        image: "EmptyLiddedCuvetteSpectrophotometry",
        altText: "Empty cuvette",
      },
      {
        name: "lidded_empty_in_spectrophotometer",
        image: "",
      },
      {
        name: "lidded_filled_in_spectrophotometer",
        image: "",
      },
      {
        name: "lidded_diluted_filled_in_spectrophotometer",
        image: "",
      },
      {
        name: "lidded_diluted_filled_hidden",
        image: "",
      },
      {
        name: "lidded_diluted_filled_appear",
        image: "FilledLiddedCuvetteSpectrophotometry",
        animation: {
          name: "dropIn",
          duration: 3,
          from: {
            top: "-800px",
          },
          to: {
            top: 0,
          },
        },
      },
    ],
  },
  {
    name: "spectrophotometer",
    image: "",
    type: "interactableObject",
    defaultState: "off",
    modals: ["SpectrophotometerConfigModal", "SpectrophotometerInfoModal"],
    states: [
      {
        name: "off",
        image: "SpectrophotometerOff",
        altText: "Spectrophotometer with lid closed",
        label: {
          text: "Spectrophotometer",
          offset: -140,
        },
        buttons: [
          {
            icon: "ConfigApparatusIcon",
            title: "Spectrophotometer settings",
            modal: "SpectrophotometerConfigModal",
            type: "Modal",
          },
          {
            icon: "OpenObjectIcon",
            title: "Open lid",
            stateUpdates: [{ nextState: "open_off" }],
            type: "UpdateState",
          },
          {
            icon: "glossary_button",
            title: "Spectrophotometer info",
            modal: "SpectrophotometerInfoModal",
            type: "Modal",
          },
        ],
      },
      {
        name: "on",
        image: "SpectrophotometerOn",
        altText: "Spectrophotometer with lid closed",
        label: {
          text: "Spectrophotometer",
          offset: -140,
        },
        buttons: [
          {
            icon: "ConfigApparatusIcon",
            title: "Spectrophotometer settings",
            modal: "SpectrophotometerConfigModal",
            type: "Modal",
          },
          {
            icon: "OpenObjectIcon",
            title: "Open lid",
            stateUpdates: [{ nextState: "open_on" }],
            type: "UpdateState",
          },
          {
            icon: "glossary_button",
            title: "Spectrophotometer info",
            modal: "SpectrophotometerInfoModal",
            type: "Modal",
          },
        ],
      },
      {
        name: "open_on",
        image: "SpectrophotometerOpenOn",
        altText: "Spectrophotometer with lid open",
        label: {
          text: "Spectrophotometer",
          offset: -60,
        },
        buttons: [
          {
            icon: "ConfigApparatusIcon",
            title: "Spectrophotometer settings",
            modal: "SpectrophotometerConfigModal",
            type: "Modal",
          },
          {
            icon: "CloseObjectIcon",
            title: "Close lid",
            stateUpdates: [{ nextState: "on" }],
            type: "UpdateState",
          },
          {
            icon: "glossary_button",
            title: "Spectrophotometer info",
            modal: "SpectrophotometerInfoModal",
            type: "Modal",
          },
        ],
      },
      {
        name: "open_off",
        image: "SpectrophotometerOpenOff",
        altText: "Spectrophotometer with lid open",
        label: {
          text: "Spectrophotometer",
          offset: -60,
        },
        buttons: [
          {
            icon: "ConfigApparatusIcon",
            title: "Spectrophotometer settings",
            modal: "SpectrophotometerConfigModal",
            type: "Modal",
          },
          {
            icon: "CloseObjectIcon",
            title: "Close lid",
            stateUpdates: [
              {
                nextState: "off",
              },
            ],
            type: "UpdateState",
          },
          {
            icon: "glossary_button",
            title: "Spectrophotometer info",
            modal: "SpectrophotometerInfoModal",
            type: "Modal",
          },
        ],
      },
      {
        name: "open_off_with_cuvette",
        image: "SpectrophotometerOffWithCuvette",
        altText: "Spectrophotometer with lid open",
        label: {
          text: "Spectrophotometer",
          offset: -60,
        },
        buttons: [
          {
            icon: "ConfigApparatusIcon",
            title: "Spectrophotometer settings",
            modal: "SpectrophotometerConfigModal",
            type: "Modal",
          },
          {
            icon: "CloseObjectIcon",
            title: "Close lid",
            stateUpdates: [
              {
                nextState: "off_with_cuvette",
              },
            ],
            type: "UpdateState",
          },
          {
            icon: "glossary_button",
            title: "Spectrophotometer info",
            modal: "SpectrophotometerInfoModal",
            type: "Modal",
          },
          {
            icon: "RemoveCuvetteIcon",
            title: "Remove cuvette",
            stateUpdates: [{ nextState: "open_off" }],
            type: "UpdateState",
            actionName: "EJECT_CUVETTE",
          },
        ],
      },
      {
        name: "open_on_with_cuvette",
        image: "SpectrophotometerOnWithCuvette",
        altText: "Spectrophotometer with lid open",
        label: {
          text: "Spectrophotometer",
          offset: -60,
        },
        buttons: [
          {
            icon: "ConfigApparatusIcon",
            title: "Spectrophotometer settings",
            modal: "SpectrophotometerConfigModal",
            type: "Modal",
          },
          {
            icon: "CloseObjectIcon",
            title: "Close lid",
            stateUpdates: [
              {
                nextState: "on_with_cuvette",
              },
            ],
            type: "UpdateState",
          },
          {
            icon: "glossary_button",
            title: "Spectrophotometer info",
            modal: "SpectrophotometerInfoModal",
            type: "Modal",
          },
          {
            icon: "RemoveCuvetteIcon",
            title: "Remove cuvette",
            stateUpdates: [{ nextState: "open_on" }],
            type: "UpdateState",
            actionName: "EJECT_CUVETTE",
          },
        ],
      },
      {
        name: "off_with_cuvette",
        image: "SpectrophotometerOff",
        altText: "Spectrophotometer with lid closed",
        label: {
          text: "Spectrophotometer",
          offset: -60,
        },
        buttons: [
          {
            icon: "ConfigApparatusIcon",
            title: "Spectrophotometer settings",
            modal: "SpectrophotometerConfigModal",
            type: "Modal",
          },
          {
            icon: "OpenObjectIcon",
            title: "Open lid",
            stateUpdates: [{ nextState: "open_off_with_cuvette" }],
            type: "UpdateState",
          },
          {
            icon: "glossary_button",
            title: "Spectrophotometer info",
            modal: "SpectrophotometerInfoModal",
            type: "Modal",
          },
        ],
      },
      {
        name: "on_with_cuvette",
        image: "SpectrophotometerOn",
        altText: "Spectrophotometer with lid closed",
        label: {
          text: "Spectrophotometer",
          offset: -140,
        },
        buttons: [
          {
            icon: "ConfigApparatusIcon",
            title: "Spectrophotometer settings",
            modal: "SpectrophotometerConfigModal",
            type: "Modal",
          },
          {
            icon: "OpenObjectIcon",
            title: "Open lid",
            stateUpdates: [{ nextState: "open_on_with_cuvette" }],
            type: "UpdateState",
          },
          {
            icon: "glossary_button",
            title: "Spectrophotometer info",
            modal: "SpectrophotometerInfoModal",
            type: "Modal",
          },
        ],
      },
    ],
  },
  {
    name: "state",
    image: "",
    type: "interactableObject",
  },
];

export default objects;
